import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt";
export let iconBolt = faBolt;
export function overwriteBolt(icon) {
    iconBolt = icon;
}
export default iconBolt;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9sdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ib2x0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxNQUFNLEVBQUUsTUFBTSwwQ0FBMEMsQ0FBQztBQUVsRSxNQUFNLENBQUMsSUFBSSxRQUFRLEdBQUcsTUFBTSxDQUFDO0FBRTdCLE1BQU0sVUFBVSxhQUFhLENBQUMsSUFBb0I7SUFDaEQsUUFBUSxHQUFHLElBQUksQ0FBQztBQUNsQixDQUFDO0FBRUQsZUFBZSxRQUFRLENBQUMifQ==